import { useCallback, useEffect, useState } from "react";
import { api, errMsg } from "@/lib/api";

export function useFetch(path, params) {
  const key = JSON.stringify(params || {});
  const [state, setState] = useState({ data: null, error: null, loading: Boolean(path) });

  const reload = useCallback(async () => {
    if (!path) return;
    setState((s) => ({ ...s, loading: true, error: null }));
    try {
      const { data } = await api.get(path, { params: JSON.parse(key) });
      setState({ data, error: null, loading: false });
    } catch (e) {
      setState({ data: null, error: errMsg(e), loading: false });
    }
  }, [path, key]);

  useEffect(() => { reload(); }, [reload]);
  return { ...state, reload, setData: (data) => setState((s) => ({ ...s, data })) };
}
